import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showToast: false,
  toastMessage: '',
  toastType: '',
};

export const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    clearToast: (_state) => initialState,
    notifyUser(state, { payload }) {
      return {
        ...state,
        showToast: payload.showToast,
        toastMessage: payload.toastMessage,
        toastType: payload.toastType,
      };
    },
  },
});

export const { clearToast, notifyUser } = toastSlice.actions;
export default toastSlice.reducer;
